
import {HeadBar} from '@/components';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {ImageProxy} from "@/http/RequestProxy.class";

const imageProxy = new ImageProxy();

export default {
name: 'preview-imgs',
directives: {
TransferDom,
},
components: {
Previewer,
FlexboxItem,
Flexbox,
HeadBar,
},
data(){
return {
query: {
img_type: 'hotel_banner',
key_id: '',
},
allList: [],
currentList: [],
group: [],
previewList: [],
selectGroupCode: 'all',
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.img-position-center')[index];
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
let rect = thumbnail.getBoundingClientRect();

return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
},
},
};
},
mounted(){
this.query.key_id = this.$route.params.hotel_id;
this.getImages();
},
methods: {
/** 获取图片数据 */
getImages(){
this.$vux.loading.show();
imageProxy.getHotelAllImages(this.query)
.then(resp => {
if(resp){
this.allList = resp.data.img_list;

if(this.group.length < 1){
this.currentList = resp.data.img_list;
this.group.push({code: 'all', tag_name: this.$i18n.t('hotel.All'), counter: resp.data.img_list.length}, ...resp.data.tag_list);
}

this.formatPreview();
}
this.$vux.loading.hide();
});
},

formatPreview(){
let temp = [];

this.currentList.forEach(it => {
temp.push({src: it.img_url, w: 600, h: 500});
});
this.previewList = temp;
},

onShowIdx(idx){
this.$refs.previewer.show(idx);
},

/** 选择图片分组 */
onSelectGroup(ev){
this.selectGroupCode = ev.target.dataset.code;

if(this.selectGroupCode == 'all'){
this.currentList = this.allList;
}else{
this.currentList = this.allList.filter(it => {
return it.tag == this.selectGroupCode;
});
}

this.formatPreview();
},
},
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/preview-imgs.vue